<template>
    <div
        :class="{
            'max-lg:flex-col': size === 'medium',
            'max-w-none max-md:flex-col lg:max-w-[33.5rem] lg:flex-col xl:max-w-[49.125rem]':
                size !== 'medium',
            '!flex-col': alignContent === 'col',
        }"
        class="relative z-20 flex w-full">
        <BaseVideo
            :size="coverSize ?? size"
            :in-column="inColumn"
            :title="name"
            :duration="duration"
            :url="url"
            :image="image"
            :image-webp="imageWebp"
            :disable-title-clamp="disableCoverTitleClamp"
            :class="alignContent === 'col' ? '!w-full' : ''" />
        <div
            :class="
                size === 'medium'
                    ? 'space-y-1 max-lg:mt-3 max-md:mt-2 md:space-y-2 lg:ml-3'
                    : 'space-y-1 max-md:mt-2 md:space-y-3 md:max-lg:ml-5 lg:mt-5'
            "
            class="w-full">
            <h3
                v-html="title"
                :class="[
                    titleSize === 'medium' ? 'text-16/150' : 'text-20/120',
                    disableCoverTitleClamp ? '' : 'line-clamp-2',
                ]"
                class="font-semibold text-ash-200 md:max-lg:h-12" />
            <p
                v-html="description"
                class="line-clamp-2 text-16/132 text-accent-100 xl:line-clamp-4" />
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseVideo from '~/components/base/base-video/BaseVideo.vue'

defineProps({
    size: {
        type: String as PropType<'medium' | 'big'>,
        default: 'medium',
    },
    name: {
        type: String as PropType<string>,
        default: null,
    },
    alignContent: {
        type: String as PropType<'row' | 'col'>,
        default: 'row',
    },
    title: {
        type: String as PropType<string>,
        default: null,
    },
    titleSize: {
        type: String as PropType<'medium' | 'large'>,
        default: 'large',
    },
    coverSize: {
        type: String as PropType<null | 'medium' | 'large'>,
        default: null,
    },
    disableCoverTitleClamp: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    description: {
        type: String as PropType<string>,
        default: null,
    },
    image: {
        type: String as PropType<string>,
        default: null,
    },
    imageWebp: {
        type: String as PropType<string>,
        default: null,
    },
    duration: {
        type: String as PropType<string>,
        default: null,
    },
    url: {
        type: String as PropType<string>,
        default: null,
    },
    inColumn: {
        type: Number as PropType<number>,
        default: 3,
    },
})
</script>
